/**
 * @desc 通过平台订单号获取退货商品
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.asMaterialRejectBill.loadBySoOrderNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/asMaterialRejectBill/loadBySoOrderNo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
